import { Button } from "antd";
import { useState } from "react";
import SelectTableList, { ISelectTableList } from "./SelectTableList";
import { strings } from "utils/localizedStrings";

interface SelectTableInputProps extends Omit<ISelectTableList, 'open' | 'setOpen' | 'value' | 'onChange'> {
  value?: any;
  onChange?: (value: any) => void;
  disable?: boolean;
  renderKey?: string;
  allOption?: boolean;
  searchInput?: boolean;
}

const SelectTableInput = ({
  value,
  onChange,
  title,
  onGetList,
  productTableProps,
  disable,
  renderKey = "name",
  allOption = true,
  searchInput = true,
}: SelectTableInputProps) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        style={{ width: "100%", textAlign: "left", justifyContent: "start" }}
        onClick={() => setOpen(true)}
        disabled={disable}
        loading={productTableProps.loading}
      >
        <div className="truncate text-left">
          {value?.[renderKey] || strings.GlobalLabels.All}
        </div>
      </Button>
      <SelectTableList
        open={open}
        setOpen={setOpen}
        title={title}
        productTableProps={productTableProps}
        value={value}
        onChange={onChange}
        onGetList={onGetList}
        allOption={allOption}
        searchInput={searchInput}
      />
    </>
  );
};

export default SelectTableInput;
